import { render, staticRenderFns } from "./RegoAnother.vue?vue&type=template&id=c600c650&scoped=true&"
import script from "./RegoAnother.vue?vue&type=script&lang=js&"
export * from "./RegoAnother.vue?vue&type=script&lang=js&"
import style0 from "./RegoAnother.vue?vue&type=style&index=0&id=c600c650&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c600c650",
  null
  
)

export default component.exports